import definitions from './definitions';
import PeopleIcon from '@mui/icons-material/People';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import Logout from '@mui/icons-material/Logout';
import LanguageIcon from '@mui/icons-material/Language';
import EditAttributesIcon from '@mui/icons-material/EditAttributes';
import SegmentIcon from '@mui/icons-material/Segment';
import Rule from '@mui/icons-material/Rule';
import TimelineIcon from '@mui/icons-material/Timeline';
import InputIcon from '@mui/icons-material/Input';
import AccountTree from '@mui/icons-material/AccountTree';
import TocIcon from '@mui/icons-material/Toc';

const dictionary = {
    audience: {
        definition: definitions.audience,
        icon: PeopleIcon,
        name: 'Audience',
        plural: 'Audiences',
        prefix: 'AU',
    },
    connection: {
        definition: definitions.connection,
        icon: SettingsEthernetIcon,
        name: 'Connection',
        plural: 'Connections',
        prefix: 'CX',
    },
    content: {
        definition: '',
        icon: TocIcon,
        name: 'Content',
        plural: 'Content',
        prefix: '',
    },
    destination: {
        definition: definitions.destination,
        icon: Logout,
        name: 'Destination',
        plural: 'Destinations',
        prefix: 'DD',
    },
    domain: {
        definition: definitions.domain,
        icon: LanguageIcon,
        name: 'Audience',
        plural: 'Audiences',
        prefix: 'DM',
    },
    property: {
        definition: definitions.property,
        icon: EditAttributesIcon,
        name: 'Domain',
        plural: 'Domains',
        prefix: 'PR',
    },
    report: {
        definition: '',
        icon: SegmentIcon,
        name: 'Report',
        plural: 'Reports',
        prefix: 'RP',
    },
    rule: {
        definition: definitions.rule,
        icon: Rule,
        name: 'Rule',
        plural: 'Rules',
        prefix: 'WR',
    },
    segment: {
        definition: definitions.segment,
        icon: TimelineIcon,
        name: 'Segment',
        plural: 'Segments',
        prefix: 'GS',
    },
    source: {
        definition: definitions.source,
        icon: InputIcon,
        name: 'Source',
        plural: 'Sources',
        prefix: 'DS',
    },
    workflow: {
        definition: definitions.workflow,
        icon: AccountTree,
        name: 'Workflow',
        plural: 'Workflows',
        prefix: 'WF',
    },
};

export default dictionary;
